/**
 * The "Learn" menu. See lib/navigation/nav-manifest.js for the entry shape and
 * the vocabulary `requires` draws from.
 */

/**
 * The Playbook and its sections: the first thing in Learn.
 *
 * @type {import("@/lib/navigation/nav-manifest").NavManifestItem}
 */
const PLAYBOOK_ITEM = {
  href: "/playbook",
  label: "Playbook",
  shortcut: "P",
  iconName: "IoBookOutline",
  requires: "workspace",
  subItems: [
    {
      href: "/playbook#company-overview",
      label: "Company Overview",
      iconName: "IoBusinessOutline",
    },
    {
      href: "/playbook#positioning",
      label: "Positioning",
      iconName: "IoFlagOutline",
    },
    {
      href: "/playbook#glossary",
      label: "Glossary",
      iconName: "IoBookOutline",
    },
    {
      href: "/playbook#our-content-faq",
      label: "Q&As",
      iconName: "IoHelpCircleOutline",
    },
    {
      href: "/playbook#fbiv",
      label: "Capability Maps",
      iconName: "Target",
    },
    {
      href: "/playbook#messaging",
      label: "Messaging / Pitch",
      iconName: "HiOutlinePresentationChartBar",
    },
    {
      href: "/playbook#objections",
      label: "Objections",
      iconName: "HiNoSymbol",
    },
    {
      href: "/playbook#discovery",
      label: "Discovery",
      iconName: "CiMap",
    },
    {
      href: "/playbook#cold-call",
      label: "Outbound & Inbound",
      iconName: "IoCallOutline",
    },
    {
      href: "/playbook#plays",
      label: "Plays",
      iconName: "LiaTheaterMasksSolid",
    },
    {
      href: "/playbook#lessons",
      label: "Lessons",
      iconName: "IoDocumentTextOutline",
    },
  ],
};

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const LEARN_ITEMS = [
  {
    // Everything assigned to you in one list: learning paths, practice and
    // tests. A training-mode rep's Home is this page.
    href: "/training",
    label: "My Training",
    heading: "Your Training",
    description:
      "Complete your assigned learning paths and practice assignments.",
    iconName: "HiOutlineClipboardDocumentCheck",
    requires: "user",
  },
  PLAYBOOK_ITEM,
  {
    href: "/dashboard/learning-paths",
    label: "Learning Paths",
    description:
      "Guided paths of resources, tests and practice, assigned to you or open to join.",
    shortcut: "L",
    iconName: "SlGraduation",
    requires: "workspace",
  },
  {
    href: "/dashboard/tests",
    label: "Tests",
    description: "Check what you know. Practice what you don't.",
    shortcut: "T",
    iconName: "IoDocumentTextOutline",
    requires: "workspace",
  },
  {
    href: "/questions",
    label: "Questions",
    iconName: "IoHelpCircleOutline",
    requires: "workspace",
  },
];
